export const examAdminErrorPages = {
  notFoundPage: {
    subtitle: "页面不存在",
    backToDashboard: "返回平台总览",
  },
  accessDenied: {
    subtitle: "当前账号无权访问这个页面",
    backToDashboard: "返回平台总览",
  },
  runtimeError: {
    title: "管理端发生了未预期错误",
    subtitle: "请刷新页面，或先返回平台总览后重试。",
  },
};
